export default __webpack_public_path__ + "static/media/forbes.423845e5.svg";